// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { FormGroup, Checkbox } from 'react-bootstrap'
import { MainSidebar } from '../components/mainsidebar'
import { SecSidebar } from '../components/secsidebar'
import config from '../config/config.json'

export class AssignTraining extends Component {
    constructor(props) {
        super(props)

        this.state = {
            workers: [],
            modules: [],
            selectedWorkersFinal: [],
            loading: true
        }

        this.init()
        this.getWorkersByProvider(this.props.env, config)
        this.getProviderModules(this.props.env, config)

        this.init = this.init.bind(this)
        this.handleSelectedWorkersFinal = this.handleSelectedWorkersFinal.bind(this)
        this.getProviderModules = this.getProviderModules.bind(this)
    }

    init() {
        if (!window.sessionStorage.getItem('authToken')) {
            this.props.router.push('/login')
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            let data = {
                profileType: storedData.profileType,
                loginStatus: storedData.loginStatus,
                authToken: storedData.authToken,
                id: storedData.uid,
                admin_first_name: storedData.fname,
                admin_last_name: storedData.lname,
                name: storedData.company,
                address: storedData.address,
                license_count: storedData.licenseCount,
                globalModules: JSON.parse(storedData.globalModules)
            }

            this.props.handleProviderDataUpdateFromSessionStorage(data)

            if ('selectedWorkersFinal' in storedData) {
                this.state = {
                    workers: [],
                    modules: [],
                    selectedWorkersFinal: JSON.parse(storedData.selectedWorkersFinal)
                }
            }
        }
        else {
            //this.props.getWorkersByProvider()
        }
    }

    getWorkersByProvider(env, config) {
        fetch(config[env] + config.api.list_workers.endpoint, {
            method: config.api.list_workers.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    workers: responseJson.workers,
                    loading: false
                })
            })
            .catch((error) => {
                console.error(error)
            })
    }

    getProviderModules(env, config) {
        fetch(config[env] + config.api.provider_modules.endpoint, {
            method: config.api.provider_modules.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    modules: responseJson.enabler_modules
                })
            })
            .catch((error) => {
                console.error(error)
            })
    }

    get records() {
        return this.state.workers.map((worker, index) => {
            //let lastActiveDate = new Date(worker.last_active_at)

            return (
                <tr key={index}>
                    <td>
                        <FormGroup>
                            <Checkbox inline id={worker.id} onClick={this.handleSelectWorkersClick} data-workerId={worker.id} data-workerName={worker.first_name + " " + worker.last_name}></Checkbox>
                        </FormGroup>
                    </td>
                    <td>
                        <label>
                            {worker.first_name + ' ' + worker.last_name}
                        </label>
                    </td>
                    <td>
                        {worker.categories}
                    </td>
                </tr>
            )
        })
    }

    handleSelectedWorkersFinal(selectedWorkersFinal) {
        this.setState({
            selectedWorkersFinal
        })

        window.sessionStorage.setItem("selectedWorkersFinal", JSON.stringify(selectedWorkersFinal))
    }

    get childWithProps() {
        return React.Children.map(this.props.children, child => {
            return (
                React.cloneElement(child, {
                    appData: this.props.appData,
                    env: this.props.env,
                    workers: this.state.workers,
                    modules: this.state.modules,
                    selectedWorkersFinal: this.state.selectedWorkersFinal,
                    handleSelectedWorkersFinal: this.handleSelectedWorkersFinal,
                    getProviderModules: this.getProviderModules,
                    loading: this.state.loading
                })
            )
        })
    }

    render() {
        return (
            <div className="dashboard-container assign-training-container page-container">
                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    profile={1}
                    appData={this.props.appData}
                />
                <SecSidebar
                    profileType={this.props.appData.profileType}
                    menuItemsKey={"workforce"}
                    profile={2}
                />
                <div className="main-body assign-training" >
                    {this.childWithProps}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/assignTraining.js